import PerfilAdmin from "./Perfil";

/* eslint-disable array-callback-return */
const HomeInterBrasil = () => {
  return <PerfilAdmin />;
};

export default HomeInterBrasil;
